import React, { useCallback } from 'react';
import useSessionVideo, { useSnapshot } from './useSessionVideo';
import styled from 'styled-components';
import RefreshingImage from '../Util/RefreshingImage';
import { VideoLibrary } from '@material-ui/icons';
import SettingsIcon from '@material-ui/icons/Settings';
import { RouteComponentProps, withRouter } from 'react-router';

interface Props extends RouteComponentProps {
  video: string;
  pitch: string;
}

const PitchSessionVideo: React.FunctionComponent<Props> = ({ video, pitch, history }) => {
  const sessionVideo = useSessionVideo(video);
  const snapshot = useSnapshot(video);

  const onClick = useCallback(() => {
    history.push('/pitch/' + pitch + '/' + video + '/calibration');
  }, [history, pitch, video]);

  const onClickShowProps = useCallback(() => {
    history.push('/pitch/' + pitch + '/' + video + '/settings');
  }, [history, pitch, video]);

  return (
    <CameraWrapper
      key={video}
      className="sciui-grid-item-xs-12 sciui-grid-item-s-6 sciui-grid-item-m-4 sciui-grid-item-l-3 sciui-grid-item-xl-2 sciui-grid-item-xxl-1 sciui-card sci-ui-bg-p-5">
      <MatchCameraWrapper>
        {snapshot ? (
          <RefreshingImage data={snapshot} onClick={onClick} />
        ) : (
          <VideoLibrary fontSize="large" style={{ margin: '0 auto' }} onClick={onClick} />
        )}
      </MatchCameraWrapper>
      <StatusWrapper className="sciui-p-x-s">
        <p style={{ flexGrow: 1 }}>{'Video ' + sessionVideo?.sortOrder}</p>
        <SettingsIcon color="primary" onClick={onClickShowProps} />
      </StatusWrapper>
    </CameraWrapper>
  );
};

const CameraWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 200px;
`;

const StatusWrapper = styled.div`
  background-color: black;
  color: white;
  height: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 0;
`;

const MatchCameraWrapper = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  height: 100%;
  flex-grow: 1;
`;
export default withRouter(PitchSessionVideo);
